var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymboleOrak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.756 2.1966L11.4192 6.66379L10.9112 4.18514C8.09894 5.37367 5.74594 7.44853 4.22271 10.1021C3.27217 11.7333 2.66815 13.5411 2.44801 15.4138C2.22787 17.2865 2.39629 19.1843 2.94286 20.9896L0.685148 21.6572C-0.518843 17.6532 -0.125679 13.3416 1.78292 9.61852C3.61055 6.0534 6.69314 3.2905 10.4326 1.84959L10.0536 0L16.756 2.1966ZM30.2033 18.8833C30.634 15.7389 29.9349 12.5374 28.2126 9.83201C26.3649 6.92972 23.4735 4.80867 20.1072 3.88616L20.7456 1.66589C24.6712 2.74948 28.042 5.22658 30.1984 8.61245C32.29 11.8966 33.093 15.8063 32.4671 19.6184L35.1877 20.5019L29.873 24.9892L28.4853 18.3254L30.2033 18.8833ZM8.43619 28.5406L10.0536 27.1872L3.35121 24.9891L4.71678 31.6529L6.61201 30.067C9.44845 32.1718 12.9231 33.3194 16.5065 33.3189C17.37 33.3197 18.2322 33.2528 19.0847 33.1189C22.697 32.5519 26.0083 30.8173 28.4853 28.1943L26.7618 26.6551C24.6327 28.9357 21.7659 30.4371 18.6385 30.9092C15.5112 31.3814 12.3122 30.7958 9.57425 29.2499C9.18349 29.0309 8.80372 28.7942 8.43619 28.5406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymboleOrak);
export default __webpack_public_path__ + "static/media/symbole_orak.ba087a105ff9656d57a7cb3db8cd3948.svg";
export { ForwardRef as ReactComponent };